<template>
  <div style="height:100%">
      <!-- メール通知 -->
      <v-card>
        <v-card-text>
          <h2 class="pl-2">{{$t("notifications.title-mail")}}</h2>
          <v-switch :label="`${mailTitle}`" v-model="emailNotification"></v-switch>
        </v-card-text>
        <!-- 言語設定 -->
        <v-card-text>
          <h2 class="pl-2">{{$t("notifications.title-langage")}}</h2>
          <v-flex xs12 sm2 class="pt-0">
            <v-select
              v-model="emailLanguage"
              :items="items"
              :label="emailLanguage"
              item-text="disp"
              item-value="code"
              single-line
              bottom
              auto
              ></v-select>
          </v-flex>
        </v-card-text>
      </v-card>
  </div>
</template>
<script>

import utils from '@/utils/utils.js'

export default {
  data () {
    return {
      emailNotification: null,
      emailLanguage: '',
      mailTitle: '',
      items: []
    }
  },
  watch: {
    mail () {
      this.setTitle()
    }
  },
  methods: {
    init () {
      console.log(this.$store.getters.settingParams)
      if (this.$store.getters.settingParams.emailNotification !== 'disable') {
        this.emailNotification = true
      } else {
        this.emailNotification = false
      }
      this.emailLanguage = this.$store.getters.settingParams.emailLanguage
      if (this.emailLanguage === undefined) {
        this.emailLanguage = 'English'
      }
      this.setTitle()
      this.getDomainConfig()
      console.log(this.items)
    },
    setTitle () {
      this.mailTitle = this.emailNotification ? this.$t('notifications.enable') : this.$t('notifications.disable')
    },
    getDomainConfig () {
      let domainConfig = utils.getDomainConfig()
      for (var language in domainConfig.emailLanguage) {
        this.items.push(domainConfig.emailLanguage[language])
      }
    }
  },
  mounted () {
    this.init()
  },
  updated () {
    var setParam = this.emailNotification ? 'enable' : 'disable'
    var setLanguage = this.emailLanguage
    if (setLanguage === '') {
      setLanguage = 'English'
    }
    if (setLanguage === '日本語') {
      setLanguage = 'Japanese'
    }
    console.log('lang', setLanguage)
    this.$store.dispatch('setSettingParam', {
      emailNotification: setParam,
      emailLanguage: setLanguage
    })
    .catch(err => {
      console.log(err)
    })
    this.setTitle()
  }
}
</script>



// WEBPACK FOOTER //
// NotificationsMail.vue?3eaca508